<template>
  <main-layout>
    <b-container>
      <b-card-body>
        <h4
          class="card-title font-weight-bold"
          style="margin-bottom: 40px"
        >
          Seite wurde nicht gefunden
        </h4>
      </b-card-body>
    </b-container>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
export default {
  components: {
    MainLayout,
  },
};
</script>
